/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/function-component-definition */

/* eslint-disable react/prop-types */
import React, { useState, useEffect, createContext } from 'react';
import { IntlProvider } from 'react-intl';
import messages_en from '../../lng-data/en.json';
import messages_fr from '../../lng-data/fr.json';
import messages_ar from '../../lng-data/ar.json';

import { getPrefLanguage } from '../helper-utils/localStorage';
import { APP_PREF_LANGUAGE } from '../../saas/AppStorageStaticNames';

export const LanguageContext = createContext();

const messages = {
  en: messages_en,
  fr: messages_fr,
  ar: messages_ar,
};

const LanguageWrapper = ({ children }) => {
  const [locale, setLocale] = useState(getPrefLanguage() || 'en');

  const changeLanguage = (lang) => {
    setLocale(lang);
    localStorage.setItem(APP_PREF_LANGUAGE, lang);
  };
  useEffect(() => {
    const storedLocale = getPrefLanguage();
    if (storedLocale && storedLocale !== locale) {
      setLocale(storedLocale);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage }}>
      <IntlProvider
        locale={locale}
        messages={messages[locale]}
        defaultLocale="en"
      >
        <main dir={locale === 'ar' ? 'rtl' : 'ltr'}>{children}</main>
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export default LanguageWrapper;
